export enum ReportType {
  MACHINE = "MACHINE",
  INSPECTION = "INSPECTION",
}

export enum ResponseStatus {
  UNADDRESSED = "UNADDRESSED",
  RESOLVED = "RESOLVED",
  DELETED = "DELETED",
}

export enum ReportActions {
  SELF_REPAIR = "SELF_REPAIR",
  REPAIR_REQUEST = "REPAIR_REQUEST",
}

export enum UploadFileType {
  USER = "users",
  MACHINE_INSPECTIONS = "machine-inspections",
  MACHINE_REPORT = "machine-reports",
  MACHINE = "machines",
  GROUP_LOGO = "group-logos",
}

export enum ReportTypeDialog {
  INSPECTION = "INSPECTION",
  INCIDENT_REPORTS = "INCIDENT_REPORTS",
  MAINTENANCE_REPORTS = "MAINTENANCE_REPORTS",
  FUEL_MAINTENANCE_REPORTS = "FUEL_MAINTENANCE_REPORTS",
  MACHINE_OPERATION_REPORTS = "MACHINE_OPERATION_REPORTS",
}

export enum MaintenanceReportType {
  GENERAL_MAINTENANCE = "GENERAL_MAINTENANCE",
  PERIODIC_MAINTENANCE = "PERIODIC_MAINTENANCE",
}

export const MACHINE_OPERATION_REPORTS = "MACHINE_OPERATION_REPORTS";
export const FUEL_MAINTENANCE_REPORTS = "FUEL_MAINTENANCE_REPORTS";
export const INCIDENT_REPORTS = "INCIDENT_REPORTS";
export const INSPECTION = "INSPECTION";
export const MAINTENANCE_REPORTS = "MAINTENANCE_REPORTS";
export const PERIODIC_MAINTENANCE_REPORTS = "PERIODIC_MAINTENANCE_REPORTS";
export const STATUS_UPDATES = "STATUS_UPDATES";

export const HourUnitMap = {
  en: "hours",
  es: "hours",
  fr: "hours",
  pt: "hours",
  ja: "時間",
  ar: "ساعة",
  ur: "گھنٹے",
  th: "ชม",
  vi: "giờ",
  lo: "ຊົ່ວໂມງ",
  km: "ម៉ោង",
  ru: "час",
} as const;

export type HourUnitLang = keyof typeof HourUnitMap;
export type HourUnit = (typeof HourUnitMap)[HourUnitLang];

export const COMMENT_MAX_LENGTH = 1000;
